module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-10.eaa2206e.mp3";